// Common or repeated strings
export const enOnly = {
    en: {
        enOnly: "EN Only",
    },
    "fr-FR": {
        enOnly: "En Anglais",
    },
    "de-DE": {
        enOnly: "In Englisch",
    },
    "it-IT": {
        enOnly: "Solo Inglese",
    },
    "ja-JP": {
        enOnly: "英語のみ",
    },
    "es-ES": {
        enOnly: "Sólo en Inglés",
    },
    "pt-BR": {
        enOnly: "Em Inglês",
    },
};
